var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutSection"},[_c('Headline'),_c('Story'),_c('Team'),_c('History'),_c('Timeline'),_c('Signup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }